import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsUiDynamicContentQuery, Footer } from '@lobos/library';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  footer$: Observable<Footer> = this.cmsQuery.footer$;

  constructor(private cmsQuery: CmsUiDynamicContentQuery) {}
}
